<template>
    <b-dropdown-item :to="to" :active="isActive(to.name)" class="cabinet-submenu-item">
        <slot></slot>
        <span v-if="attention" class="cabinet-action-indicator" :title="attentionTitle" role="img" aria-label="Требуется действие">!</span>
    </b-dropdown-item>
</template>

<script>
export default {
    name: 'cabinet-submenu-item',
    props: {
        to: {
            required: true
        },
        attention: {
            type: Object,
            default: null
        }
    },
    computed: {
        attentionTitle() {
            if (!this.attention) {
                return '';
            }

            return Object.values(this.attention.actions)
                .map((action) => `${action.title}: ${action.count}`)
                .join(', ');
        }
    },
    methods: {
        isActive(path) {
            return this.$route.name === path;
        }
    }
};
</script>

<style scoped>
.cabinet_menu li {
    position: relative;
    background: #fff;
}

.cabinet_menu li a {
    border-left: 8px solid transparent;
    font-size: 14px;
    padding: 10px;
    color: var(--grey-color);
}

.cabinet_menu li + li {
    border-top: 1px solid rgba(149, 155, 164, 0.25);
}

.provider_menu .cabinet_submenu li {
    border-top: none !important;
}

.provider_menu .cabinet_submenu li a {
    font-size: 14px;
    color: var(--grey-color);
}

.provider_menu .cabinet_submenu li a:active {
    background: transparent;
}

.provider_menu .cabinet_submenu li a:hover {
    background: transparent;
}

.cabinet_menu li .router-link-active,
.cabinet_menu li .active,
.cabinet_menu li.notify_active {
    border-left: 8px solid var(--green-color);
    color: var(--green-color);
    font-weight: 600;
}

.cabinet-action-indicator {
    position: absolute;
    right: 1px;
    top: 50%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 14px;
    height: 14px;
    border: 1px solid #dc3545;
    border-radius: 50%;
    color: #dc3545;
    font-size: 10px;
    font-weight: 700;
    line-height: 1;
    transform: translateY(-50%);
}
</style>
